import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogResult, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { DialogHelperService } from '../../services/dialog-helper.service';
import { ErrorService } from '../../services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'app-setting-list',
  templateUrl: './setting-list.component.html',
  styleUrl: './setting-list.component.scss'
})
export class SettingListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  activeDialog: string = '';

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private dialogHelperService: DialogHelperService,
    private errorService: ErrorService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.settingList,
      () => API_ENDPOINTS.dashboard.getSettings,
      false);
  }

  ngOnInit(): void {
    this.route.url.subscribe((url) => {
      if (url.length === 0) {
        // In the case where this component is being loaded as part of the default (empty) route, we want to force it
        // to the Setting List route so that the menu will highlight the selected option.
        this.router.navigate(['/', ROUTE_CONSTANTS.setting.list]);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    // No filters are implemented in this dashboard
  }

  actionButton_settingsGrid_datagrid_edit_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.setting.prefix, event.event.data.id]);
  }

  actionButton_settingsGrid_datagrid_custom_bulkUpdateClientInactiveDate_Clicked(event: any) {
    this.dialogService
      .showConfirm(POP_UP_CODES.settingList.confirmBulkUpdateClientInactiveDate)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.spinnerService.showSpinner();
            const endpoint = API_ENDPOINTS.person.bulkUpdateClientInactiveDate;
            this.registerSubscription(
              this.appDataService.postAndFetchData(endpoint)
                .pipe(
                  take(1),
                  this.errorService.errorHandler(),
                  finalize(() => this.spinnerService.hideSpinner())
                )
                .subscribe(data => {
                  if (data?.status === SAVE_RESULT_STATUS.success) {
                    if (SERVER_ERROR_POP_UP_CODES.bulkUpdateClientInactiveDate.includes(data.message)) {
                      this.activeDialog = data.message;
                      this.dialogHelperService.showDialog(this.activeDialog, {}, data.details, 'Errors:');
                    }
                    else {
                      this.activeDialog = POP_UP_CODES.settingList.clientInactiveDateBulkUpdateCompleted;
                      this.dialogService.showDialog(this.activeDialog);
                    }
                  }
                })
            );
            break;
          }
        }
      });
  }

  actionButton_settingsGrid_datagrid_custom_bulkUpdatePlacementEndDate_Clicked(event: any) {
    this.dialogService
      .showConfirm(POP_UP_CODES.settingList.confirmBulkUpdatePlacementEndDate)
      .pipe(take(1))
      .subscribe(data => {
        switch (data as DialogResult) {
          case DialogResult.ACCEPTED: {
            this.spinnerService.showSpinner();
            const endpoint = API_ENDPOINTS.careAllowancePlacement.bulkUpdatePlacementEndDates;
            this.registerSubscription(
              this.appDataService.postAndFetchData(endpoint)
                .pipe(
                  take(1),
                  this.errorService.errorHandler(),
                  finalize(() => this.spinnerService.hideSpinner())
                )
                .subscribe(data => {
                  if (data?.status === SAVE_RESULT_STATUS.success) {
                    if (SERVER_ERROR_POP_UP_CODES.bulkUpdatePlacementEndDate.includes(data.message)) {
                      this.activeDialog = data.message;
                      this.dialogHelperService.showDialog(this.activeDialog, {}, data.details, 'Errors:');
                    }
                    else {
                      this.activeDialog = POP_UP_CODES.settingList.placementEndDateBulkUpdateCompleted;
                      this.dialogService.showDialog(this.activeDialog);
                    }
                  }
                })
            );
            break;
          }
        }
      });
  }
}
